var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFDBDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5658 25.4922C28.891 24.9177 27.0719 24.9218 25.3997 25.504C25.2782 25.5474 25.17 25.6217 25.0859 25.7196C25.0018 25.8175 24.9446 25.9356 24.92 26.0622L24.3671 28.8286C24.3426 28.9509 24.288 29.0652 24.2082 29.1612C24.1284 29.2571 24.026 29.3316 23.9102 29.3779L19.4746 31.1522C19.3243 31.2128 19.1584 31.223 19.0018 31.1812C18.8453 31.1394 18.7065 31.0478 18.6065 30.9202C17.9367 30.0542 17.6056 28.9737 17.6751 27.8811C17.7446 26.7884 18.21 25.7586 18.9841 24.9844C21.3752 22.5933 24.6182 21.25 27.9997 21.25C31.3812 21.25 34.6242 22.5933 37.0153 24.9844C37.7895 25.7586 38.2548 26.7884 38.3243 27.8811C38.3939 28.9737 38.0627 30.0542 37.3929 30.9202C37.2929 31.0478 37.1542 31.1394 36.9976 31.1812C36.8411 31.223 36.6751 31.2128 36.5248 31.1522L32.0854 29.3764C31.9706 29.3305 31.8689 29.2568 31.7894 29.1621C31.7099 29.0674 31.6551 28.9544 31.6298 28.8334L31.0476 26.0454C31.022 25.9194 30.9641 25.8022 30.8796 25.7052C30.7952 25.6083 30.687 25.5349 30.5658 25.4922Z",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 34.75H36.25",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FDF1F2",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndVideo);
export default __webpack_public_path__ + "static/media/end-video.c506bd9ddb9ec1adbf9f6b625a9f4895.svg";
export { ForwardRef as ReactComponent };